import React from "react";
import {
	useTranslate,
	ReferenceInput,
	AutocompleteInput,
	required,
	ReferenceArrayInput,
} from "react-admin";
import { Button as MuiButton, Box, Grid, Typography, LinearProgress } from "@material-ui/core";
import { StoragePlaceReferenceInput } from "components/inputs/StoragePlaceReferenceInput";
import { Form } from "react-final-form";
import AutocompleteArrayInputEx from "../../_extensions/react-admin/ra-ui-materialui/src/input/AutocompleteArrayInputEx";
import { AutoSelectPalletsByPlace } from "../shared/AutoSelectPalletsByPlace";

export const MovementForm = ({ onSubmit, onCancel, loading, terminalId, classes, lastTaskId }) => {
	const translate = useTranslate();
	const t = (field) => `resources.storage-transactions.fields.${field}`;
	const tDialog = (field) => `resources.storage-transactions.dialogs.${field}`;
	const [palletsLoading, setPalletsLoading] = React.useState(false);

	const initialValues = React.useMemo(
		() => (lastTaskId ? { task_id: lastTaskId } : {}),
		[lastTaskId]
	);

	const handlePalletsLoadingChange = React.useCallback((isLoading) => {
		setPalletsLoading(isLoading);
	}, []);

	return (
		<Box className={classes.formSection}>
			<Typography className={classes.formTitle}>
				{translate(tDialog("move_description"))}
			</Typography>
			<Form
				onSubmit={onSubmit}
				initialValues={initialValues}
				render={({ handleSubmit }) => (
					<form onSubmit={handleSubmit}>
						<AutoSelectPalletsByPlace
							placeFieldName="from_place_id"
							onLoadingChange={handlePalletsLoadingChange}
						/>
						<Grid container spacing={2} className={classes.formGrid}>
							<Grid item xs={12} sm={6} md={3}>
								<StoragePlaceReferenceInput
									terminalId={terminalId}
									source="from_place_id"
									label={t("from_place")}
									allowEmpty
									validate={required()}
									autocompleteProps={{ margin: "dense" }}
								/>
							</Grid>
							<Grid item xs={12} sm={6} md={3}>
								<StoragePlaceReferenceInput
									terminalId={terminalId}
									source="to_place_id"
									label={t("to_place")}
									allowEmpty
									validate={required()}
									autocompleteProps={{ margin: "dense" }}
								/>
							</Grid>
							<Grid item xs={12} sm={6} md={2}>
								<ReferenceInput
									source="task_id"
									reference="tasks"
									label={t("task")}
									filter={{ terminal_id: [terminalId] }}
									allowEmpty
									validate={required()}
								>
									<AutocompleteInput resettable optionText="title" margin="dense" />
								</ReferenceInput>
							</Grid>
							<Grid item xs={12} sm={6} md={2} className={classes.palletsInput}>
								<ReferenceArrayInput
									source="pallet_ids"
									reference="pallets"
									label={t("pallets")}
									allowEmpty
									filter={{ terminal_id: terminalId }}
								>
									<AutocompleteArrayInputEx resettable optionText="sscc" margin="dense" />
								</ReferenceArrayInput>
								{palletsLoading && <LinearProgress style={{ marginTop: -4 }} />}
							</Grid>
							<Grid item xs={12} sm={12} md={2}>
								<Box display="flex" gap={1} height="100%" alignItems="flex-end" pb={0.5}>
									<MuiButton onClick={onCancel} disabled={loading} variant="outlined" style={{ marginRight: 8 }}>
										{translate("osfc.buttons.cancel")}
									</MuiButton>
									<MuiButton type="submit" color="primary" disabled={loading} variant="contained">
										{translate("resources.storage-transactions.actions.move_pallet")}
									</MuiButton>
								</Box>
							</Grid>
						</Grid>
					</form>
				)}
			/>
		</Box>
	);
};
